/**
 * Directive to handle Enter key press on search forms
 * Usage: v-enter-search="handleSearch"
 * 
 * This directive listens for Enter key press on any input field within the element
 * and calls the provided handler function
 */
export default {
    bind(el, binding) {
        if (typeof binding.value !== 'function') {
            console.warn('v-enter-search expects a function')
            return
        }

        // Store the handler in the element for later unbinding
        el._enterSearchHandler = (event) => {
            // Check if Enter key was pressed and target is an input/textarea
            if (event.key === 'Enter' && 
                (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA')) {
                // Prevent default form submission if inside a form
                event.preventDefault()
                
                // Call the search handler
                binding.value()
            }
        }

        // Add event listener for keydown on the container element
        el.addEventListener('keydown', el._enterSearchHandler)
    },

    unbind(el) {
        // Clean up event listener when directive is unbound
        if (el._enterSearchHandler) {
            el.removeEventListener('keydown', el._enterSearchHandler)
            delete el._enterSearchHandler
        }
    }
}
